import React, { Fragment } from 'react';

import { Author } from '../../interfaces/authors';
import NameItem from './NameItem';

interface NameListProps {
  authors: Author[];
  withTooltip?: boolean;
}

const NameList = ({ authors, withTooltip }: NameListProps) => {
  return (
    <>
      By{' '}
      {authors.map((author, index) => (
        <Fragment key={index}>
          {index > 0 && index < authors.length - 1 && ', '}
          {authors.length > 1 && index === authors.length - 1 && ' and '}
          <NameItem author={author} withTooltip={withTooltip} />
        </Fragment>
      ))}
    </>
  );
};

export default NameList;
